import { types } from 'mobx-state-tree';

import OrderAddress from './OrderAddress';
import OrderMethod from './OrderMethod';

const OrderPayment = types.model({
  address: types.maybeNull(OrderAddress),
  method: types.maybeNull(OrderMethod),
});

export default OrderPayment;
